<form class="form" [formGroup]="formGroup">
  @for (field of formConfig; track field) {
    <!-- Section -->
    @if (field?.type === 'Section' && isVisible(field)) {
      <div class="field mt-8 section">
        <label class="field-label bd-field-label">{{ field?.text }}</label>
      </div>
    }
    <!-- Container -->
    @if (field?.type === 'Container' && isVisible(field)) {
      <div class="field mt-8 container">
        <label class="field-label bd-field-label">{{ field?.text }}</label>
      </div>
    }
    <!-- Input Text -->
    @if (field?.type === 'Textbox' && !field?.multiLine && !field?.password && isVisible(field)) {
      <div class="field mt-8 inputtext bd-text-field">
        <label class="field-label bd-field-label" [class.required]="field?.isRequired">{{
          field?.text
        }}</label>
        <input
          class="bd-text-input tall"
          formControlName="{{ field?.name || field?.id }}"
          value="{{ field?.defaultValue }}"
          [attr.required]="field?.isRequired || null"
        />
      </div>
    }
    <!-- Password -->
    @if (field?.type === 'Password' && !field?.multiLine && isVisible(field)) {
      <div class="field mt-8 password">
        <label class="field-label bd-field-label" [class.required]="field?.isRequired">{{
          field?.text
        }}</label>
        <input
          class="bd-text-input tall"
          formControlName="{{ field?.name || field?.id }}"
          type="password"
          blazePasswordVisibilityToggle
          placeholder="password"
        />
      </div>
    }
    <!-- Textarea -->
    @if (field?.type === 'Text' && isVisible(field)) {
      <div class="field mt-8 textarea">
        <label class="field-label bd-field-label" [class.required]="field?.isRequired">{{
          field?.text
        }}</label>
        <textarea
          [attr.required]="field?.isRequired || null"
          class="bd-text-input tall"
          formControlName="{{ field?.name || field?.id }}"
        >
          {{ field?.defaultValue }}
          </textarea
        >
      </div>
    }
    <!-- Checkbox -->
    @if (field?.type === 'Checkbox' && isVisible(field)) {
      <div class="field mt-8 checkbox">
        <blaze-checkbox formControlName="{{ field?.name || field?.id }}">{{
          field?.text
        }}</blaze-checkbox>
      </div>
    }
    <!-- Radio buttons -->
    @if (field?.type === 'Radio' && isVisible(field)) {
      <div class="field mt-8 radio">
        <label class="field-label bd-field-label">{{ field?.text }}</label>
        <mat-radio-group
          [attr.required]="field?.isRequired || null"
          aria-label="Select an option"
          formControlName="{{ field?.name || field?.id }}"
        >
          @for (value of field?.values; track value) {
            <mat-radio-button class="p-4" value="{{ value }}">{{ value }}</mat-radio-button>
          }
        </mat-radio-group>
        @if (showError(field?.name || field?.id)) {
          <div class="bd-error">Please select connection format</div>
        }
      </div>
    }
  }
</form>
